import React from 'react';
import parse from 'html-react-parser';

const Label = ({ label, required }) => (
  <span className="label">
    {parse(label)} {required ? <span>*</span> : ``}
  </span>
);

export default Label;
